module.exports = __webpack_public_path__ + "static/media/iim-indore-logo.80aed84f.png";